const NAMESPACE = 'explorer/filters';

const SET_DATE = `${NAMESPACE}/SET_DATE`;
const SET_PRICE = `${NAMESPACE}/SET_PRICE`;

export function setDate(date) {
    return { type: SET_DATE, date };
}

export function setPrice(price) {
    return { type: SET_PRICE, price };
}

function _setDate(state, date) {
    if (!date) {
        const {
            date: _dateToRemove,
            ...newState
        } = state;

        return newState;
    }

    return { ...state, date };
}

function _setPrice(state, price) {
    if (!price) {
        const {
            price: _priceToRemove,
            ...newState
        } = state;

        return newState;
    }

    return { ...state, price };
}

const INITIAL_STATE = {};
export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_DATE:
            return _setDate(state, action.date);
        case SET_PRICE:
            return _setPrice(state, action.price);
        default:
            return state;
    }
}
